import keymirror from "../utils/keymirror";

export const FeedbackConstants = keymirror(
    {
        OPEN_FEEDBACK_DIALOG: null,
        CLOSE_FEEDBACK_DIALOG: null,
        SUBMIT_FEEDBACK: null,
        SUBMIT_FEEDBACK_SUCCESS: null,
        SUBMIT_FEEDBACK_FAILURE: null
    },
    "feedback"
);



// WEBPACK FOOTER //
// ./src/constants/feedback.constants.js